import { createSlice } from "@reduxjs/toolkit";
import { getAgencyTrackingLogList } from "./thunk";

export interface IState {
  lstTrackingLog: any;
  isTrackingLogLoading: boolean;
  isTrackingLogSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  lstTrackingLog: null,
  isTrackingLogLoading: false,
  isTrackingLogSuccess: false,

  error: {},
};

const AgencyTrackingLogSlice = createSlice({
  name: "AgencyTrackingLog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get tracking logs
    builder.addCase(getAgencyTrackingLogList.pending, (state: IState, action: any) => {
      state.isTrackingLogLoading = true;
    });
    builder.addCase(
      getAgencyTrackingLogList.fulfilled,
      (state: IState, action: any) => {
        state.lstTrackingLog = action.payload.data;
        state.isTrackingLogSuccess = true;
        state.isTrackingLogLoading = false;
      }
    );
    builder.addCase(
      getAgencyTrackingLogList.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isTrackingLogSuccess = false;
        state.isTrackingLogLoading = false;
      }
    );
  },
});

export default AgencyTrackingLogSlice.reducer;